module.exports = __webpack_public_path__ + "static/media/bg.f3289f81.jpg";